import { useEffect, useState } from "react";

import FairPortfolio from "./FairPortfolio";
import ScenarioInvestmentOptimization from "./ScenarioInvestmentOptimization";
import { useHelpContext } from "../help/HelpContext";
import AnalyticalDecisionJourney from "../components/analytical_journey/AnalyticalDecisionJourney";
import TreatmentEvidencePanel from "../components/TreatmentEvidencePanel";
import { formatEconomicHorizon } from "../components/EconomicBasisDisclosure";

import {
  getPlatformSettings,
  fetchPlatformSettings,
} from "../lib/platformSettings";


export default function InvestmentOptimization() {
  const [scope, setScope] = useState("portfolio");
  const { setCurrentViewId } = useHelpContext();

  useEffect(() => {
    setCurrentViewId(scope);
    return () => setCurrentViewId(null);
  }, [scope, setCurrentViewId]);

  const [settings, setSettings] = useState(
    () => getPlatformSettings() || {}
  );

  useEffect(() => {
    let isActive = true;

    const loadSettings = async () => {
      try {
        const freshSettings = await fetchPlatformSettings();
        if (!isActive) return;
        setSettings(freshSettings);
      } catch (err) {
        console.error("Error loading platform settings:", err);
      }
    };

    loadSettings();

    return () => {
      isActive = false;
    };
  }, []);

  return (
    <div className="p-6 space-y-6">

   
      <div>
        <p className="text-xs uppercase tracking-[0.25em] text-slate-400">
          Risk Intelligence
        </p>
        <h1 className="text-2xl font-semibold text-slate-900 mt-1">
          Risk Investment Optimization
        </h1>

        <p className="text-sm text-slate-500 mt-1">
          Analyze how different investment levels affect quantified digital risk exposure across the portfolio or individual FAIR scenarios.
        </p>

        <p className="text-xs text-slate-400 mt-1">
          Monte Carlo: {settings.simulations.toLocaleString()} simulations ·
          Confidence: {settings.confidenceLevel} ·
          Loss model: {settings.lossModel} ·
          Economic Horizon: {formatEconomicHorizon(settings.economicHorizonYears)}
        </p>
      </div>

      <AnalyticalDecisionJourney currentStage="optimize" />
      <TreatmentEvidencePanel />

      <div className="mt-8 border-b border-slate-300">
        <div className="flex gap-4">
          <button
            onClick={() => setScope("portfolio")}
            className={`relative flex items-center gap-3 px-6 py-4 rounded-t-2xl border text-sm font-semibold transition ${
              scope === "portfolio"
                ? "bg-amber-50 text-amber-700 border-amber-300 border-b-amber-50"
                : "bg-white text-slate-600 border-slate-200 hover:bg-slate-50"
            }`}
          >
            Portfolio
            {scope === "portfolio" && (
              <span className="absolute -bottom-[6px] left-1/2 -translate-x-1/2 w-3 h-3 bg-slate-400 rotate-45" />
            )}
          </button>

          <button
            onClick={() => setScope("scenario")}
            className={`relative flex items-center gap-3 px-6 py-4 rounded-t-2xl border text-sm font-semibold transition ${
              scope === "scenario"
                ? "bg-amber-50 text-amber-700 border-amber-300 border-b-amber-50"
                : "bg-white text-slate-600 border-slate-200 hover:bg-slate-50"
            }`}
          >
            Scenario
            {scope === "scenario" && (
              <span className="absolute -bottom-[6px] left-1/2 -translate-x-1/2 w-3 h-3 bg-slate-400 rotate-45" />
            )}
          </button>

        </div>
      </div>

      {scope === "portfolio" && <FairPortfolio embedded />}

      {scope === "scenario" && <ScenarioInvestmentOptimization />}

    </div>
  );
}
